import React, { useState } from 'react';

/**
 * Props for the ImagePopup component
 */
interface ImagePopupProps {
  thumbnailSrc: string;
  fullSizeSrc: string;
  altText: string;
}

/**
 * Component that displays a thumbnail image that can be clicked to show a full-size popup
 */
const ImagePopup: React.FC<ImagePopupProps> = ({ thumbnailSrc, fullSizeSrc, altText }) => {
  // State to track if the popup is visible
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Toggle popup visibility
  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  // Don't render anything if there was an error loading the image
  if (imageError) {
    return null;
  }

  return (
    <div className="image-popup-container">
      {/* Thumbnail image */}
      <img 
        src={thumbnailSrc} 
        alt={altText} 
        className="thumbnail-image" 
        onClick={togglePopup}
        onError={() => setImageError(true)}
      />
      
      {/* Full-size popup image */}
      {isPopupVisible && (
        <div className="popup-overlay" onClick={togglePopup}>
          <div className="popup-content">
            <img 
              src={fullSizeSrc || thumbnailSrc} 
              alt={altText} 
              className="full-size-image" 
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImagePopup; 